module.exports = __webpack_public_path__ + "img/spinner-200.1e008061.gif";